export const mutations = {
  RESET: 'RESET',
};

export const actions = {};
